<template lang="pug">
transition(name="bounce", mode="out-in")
    v-btn(:key="selected.name", v-bind="$attrs", v-on="$listeners", icon, :disabled="disabled")
        v-icon(:color="selected.color || 'textColor'", :size="selected.size") {{ selected.icon }}
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "ReactionIconButton",
  props: {
    selected: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
})
</script>

<style lang="sass" scoped>
.bounce-enter-active
    transition: opacity .2s, transform .2s ease-in-out
    transform: scale(0.8)
.bounce-leave-active
    transition: opacity .2s
.bounce-enter
    opacity: 0
    transform: scale(1.4)
.bounce-leave-to
    opacity: 0
</style>
